/**
 * @description
 * Path of image used in the application.
 */
export const PATH_ACCESS_DENIED_IMAGE =
  '/asset/Image/Error/accessDeniedLock.svg';
